// extracted by mini-css-extract-plugin
export var cardLayout = "_6s-1";
export var paginationContainer = "_6s-0";